import { CARD_LIMIT } from './Data';

export const URL_GET_LIST_REFERRAL = `/wispet-referrals?_limit=${CARD_LIMIT}%(params)s`;
export const URL_GET_DETAIL_REFERRAL = `/wispet-referrals/%(id)s`;
export const URL_GET_REFERRAL_MEMBERS = `/wispet-referrals/%(id)s/referrals`;

export const type = {
   GET_LIST_REFERRAL_LOADING: 'GET_LIST_REFERRAL_LOADING',
   GET_LIST_REFERRAL_SUCCESS: 'GET_LIST_REFERRAL_SUCCESS',
   GET_LIST_REFERRAL_FAILED: 'GET_LIST_REFERRAL_FAILED',

   GET_DETAIL_REFERRAL_LOADING: 'GET_DETAIL_REFERRAL_LOADING',
   GET_DETAIL_REFERRAL_SUCCESS: 'GET_DETAIL_REFERRAL_SUCCESS',
   GET_DETAIL_REFERRAL_FAILED: 'GET_DETAIL_REFERRAL_FAILED',

   GET_REFERRAL_MEMBERS_LOADING: 'GET_REFERRAL_MEMBERS_LOADING',
   GET_REFERRAL_MEMBERS_SUCCESS: 'GET_REFERRAL_MEMBERS_SUCCESS',
   GET_REFERRAL_MEMBERS_FAILED: 'GET_REFERRAL_MEMBERS_FAILED',
};
